import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";

const days = [
  { label: "S", value: "Sunday" },
  { label: "M", value: "Monday" },
  { label: "T", value: "Tuesday" },
  { label: "W", value: "Wednesday" },
  { label: "T", value: "Thursday" },
  { label: "F", value: "Friday" },
  { label: "S", value: "Saturday" },
];

const WeekDayPicker = ({ title, handleDaySelection }) => {
  const [selectedDays, setSelectedDays] = useState([]);
  const handleDayChange = (event, title) => {
    console.log("child newday", event.target.value);
    if (title === "Weekdays 1") {
      handleDaySelection(event.target.value, 0);
    } else {
      handleDaySelection(event.target.value, 1);
    }
  };

  useEffect(() => {
    console.log("theeeeeeeeee", selectedDays);
  }, [selectedDays]);

  const hanldeNothing = (event) => {
    console.log("Hiiiiiiiiiiiiiiiiithis calll is not recorded");
    console.log("hiiii");
    // const {value} = event.target
    if(selectedDays.includes(event.target.name)){
      setSelectedDays((prev)=>prev.filter((item)=>item !== event.target.name))
    }else{
      setSelectedDays((prev)=>[...prev, event.target.value])
    }
    console.log('runnned')
  };

  return (
    <div>
      <h3 className="text-md font-semibold">{title}</h3>

      <ToggleButtonGroup
        value={selectedDays}
        onChange={(event) => {
          handleDayChange(
            event,
            title === "Weekdays 1" ? "Weekdays 1" : "Weekdays 2"
          );
          // handleDays(event);
        }}
        aria-label={title}
        size="small"
        sx={{ display: "flex", gap: 1, mt: 1 }}
      >
        {days.map((day) => (
          <ToggleButton
            key={day.value}
            value={day.value}
            onClick={hanldeNothing}
            sx={{
              borderRadius: "50%",
              width: 40,
              height: 40,
              fontSize: "16px",
              fontWeight: "bold",
              backgroundColor: selectedDays?.includes(day.value)
                ? "#f5f5f5"
                : "#f5f5f5",
              color: selectedDays?.includes(day.value) ? "#fff" : "#000",
              "&.Mui-selected": { backgroundColor: "#0C7240", color: "#fff" },
            }}
          >
            {day.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default WeekDayPicker;
